import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll to top if there's a hash (like /#products for Features)
    if (hash) {
      // Let the hash navigation happen naturally
      const element = document.getElementById(hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      return;
    }

    // Scroll to top for regular page navigation
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.querySelector('[data-app-scroll-container="true"]')?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
